import { commonTypes } from '../common';

export const initialState = {
  fundingInfo: {
    selectedFundingOffer: null,
  },
};

const UINeedsVTLReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_SELECTED_FUNDING_OFFER: {
      const {
        selectedFundingOffer,
      } = action.payload;

      const newState = {
        ...state,
        fundingInfo: {
          ...state.fundingInfo,
          selectedFundingOffer,
        },
      };
      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {

};

export default UINeedsVTLReducer;
